import { tss } from 'tss-react/mui';

const useStyles = tss.create(() => ({
  caseSocReview: {
    overflow: 'auto',
    padding: '0.5rem 0',
    width: '100%',
    '.kvResponsive': {
      width: '50%'
    },
    '.kvValue': {
      fontWeight: 'normal'
    }
  },
  reason: {
    width: '100% !important'
  }
}));

export default useStyles;
